export default __webpack_public_path__ + "static/media/Ch4b.9e7236b7.gif";